import firebase from "firebase/compat/app";
import { getStorage /*, ref */ } from "@firebase/storage";
import { getFirestore /*, collection */ } from "@firebase/firestore";
import { getAuth } from "firebase/auth";
import "firebase/storage";
import "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCzWL8bn0bwtRMfP8hHpD4mIMQ6gCbklKw",
  authDomain: "mema-3473f.firebaseapp.com",
  projectId: "mema-3473f",
  storageBucket: "mema-3473f.appspot.com",
  messagingSenderId: "133812913789",
  appId: "1:133812913789:web:906c9d3219b97748d09314",
  measurementId: "G-Y7TXZ848M1",
};
// Initialize Firebase
const app = firebase.initializeApp(firebaseConfig);

const projectStorage = getStorage(app);
const projectFirestoreDB = getFirestore();
//const timestamp = firebase.firestore.FieldValue.serverTimestamp;

// const storageRef = ref(projectStorage);  // if i want to export these guys some time
//const memeImagesCollectionRef = collection(projectFirestoreDB, "memeImages");
//const timestamp = firebase.firestore.Timestamp.now().seconds;

/* const uiConfig = {
  signInFlow: "popup",
  // Redirect to /signedIn after sign in is successful. Alternatively you can provide a callbacks.signInSuccess function.
  signInSuccessUrl: "/", // home page
  // We will display Google and email as auth providers.
  signInOptions: [
    firebase.auth.EmailAuthProvider.PROVIDER_ID,
    firebase.auth.GoogleAuthProvider.PROVIDER_ID,
  ],
}; */

//ui.start("#firebaseui-auth-container", uiConfig); // HMMMM

/* function SignInScreen() {
  return (
    <div>
      <div id="firebaseui-auth-container"></div>
      <h1></h1>
      {
        <StyledFirebaseAuth
          uiConfig={uiConfig}
          firebaseAuth={firebase.auth()}
        />
      }
    </div>
  );
} */
const auth = getAuth(app);
export { projectStorage, projectFirestoreDB, auth };
